export const userImgGetter = s => {
  if (s.user.avatar_file_id) {
    return `${process.env.VUE_APP_API_URL}files/${s.user.avatar_file_id}`;
  } else {
    return "/img/default_avatar.jpg";
  }
};
